module.exports = __webpack_public_path__ + "static/img/report3d_img2.d022a447.png";